var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 126,
    viewBox: "0 0 190 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.866 86.3424C132.465 97.3156 110.898 119.628 84.3149 111.37C71.9516 107.528 72.9987 101.152 63.5977 92.7497C57.994 87.7415 49.9426 83.9545 47.7034 76.6747C45.769 70.391 46.9552 63.6372 50.3089 59.2442C57.8517 49.3648 73.0787 42.5996 88.0822 58.1657C103.086 73.7317 130.319 58.0416 131.866 86.3424Z",
    fill: "url(#paint0_linear_245_942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.104 39.5754C121.331 42.7225 117.449 43.1549 111.229 42.5568C106.551 42.1063 102.286 41.7575 97.6079 39.2205C94.3336 37.446 91.7418 35.0451 89.85 32.7132C87.8001 30.1872 84.9389 27.3041 86.3416 24.4399C88.269 20.5053 99.4163 17.1915 110.24 22.6106C122.131 28.5651 124.838 36.4998 123.104 39.5754Z",
    fill: "url(#paint1_linear_245_942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.826 18.5969C112.711 18.5557 112.595 18.5184 112.477 18.485C112.438 18.4739 112.399 18.4619 112.36 18.452C112.277 18.4309 112.193 18.4109 112.108 18.392C112.068 18.3833 112.028 18.3753 111.987 18.3678C111.903 18.3521 111.818 18.338 111.733 18.3254C111.683 18.3185 111.634 18.3122 111.584 18.3065C111.547 18.3025 111.511 18.2983 111.475 18.2949C111.417 18.2897 111.36 18.2853 111.303 18.2819C111.272 18.2802 111.242 18.2771 111.212 18.276C111.123 18.2718 111.034 18.2696 110.945 18.2695H69.9705C69.5966 18.2693 69.2236 18.3068 68.8573 18.3815C66.5188 18.8577 64.7191 20.8076 64.4738 23.2152C64.4548 23.4007 64.4453 23.5884 64.4453 23.7787V107.286C64.4453 109.67 65.9645 111.7 68.0906 112.468C68.1001 112.471 68.1096 112.474 68.1191 112.477C68.2246 112.514 68.3317 112.548 68.4395 112.579C68.4786 112.59 68.5172 112.602 68.5569 112.612C68.5983 112.622 68.6399 112.632 68.6813 112.642C68.7233 112.652 68.7659 112.662 68.8086 112.672C68.8489 112.681 68.8892 112.688 68.9302 112.696C69.0144 112.712 69.0989 112.726 69.1837 112.738C69.2329 112.745 69.2827 112.751 69.333 112.757C69.4263 112.768 69.5199 112.776 69.6137 112.782C69.6439 112.784 69.6741 112.787 69.7045 112.788C69.7928 112.792 69.8816 112.794 69.9709 112.794H110.947C111.137 112.794 111.326 112.785 111.512 112.766C114.112 112.503 116.18 110.441 116.444 107.848C116.463 107.663 116.472 107.475 116.472 107.285V23.7787C116.471 21.3941 114.952 19.3641 112.826 18.5969Z",
    fill: "#986060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4587 108.815C92.2179 108.815 93.6439 107.397 93.6439 105.647C93.6439 103.897 92.2179 102.479 90.4587 102.479C88.6995 102.479 87.2734 103.897 87.2734 105.647C87.2734 107.397 88.6995 108.815 90.4587 108.815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5005 23.002H85.6794C85.3861 23.002 85.1484 23.2384 85.1484 23.53C85.1484 23.8216 85.3861 24.058 85.6794 24.058H95.5005C95.7937 24.058 96.0314 23.8216 96.0314 23.53C96.0314 23.2384 95.7937 23.002 95.5005 23.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.9 53.895C153.35 51.7116 148.16 48.5227 145.386 50.4453C144.535 46.2858 143.739 43.6917 140.957 41.6427C138.176 39.5935 133.534 42.2719 132.789 47.882C132.044 45.5758 128.254 42.4676 125.209 45.0884C122.393 47.5137 122.11 51.5772 122.404 53.8912H153.9V53.895Z",
    fill: "url(#paint2_linear_245_942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3125 34.6206C36.6817 33.1501 40.171 31.0025 42.0357 32.2973C42.608 29.4959 43.1434 27.7489 45.0134 26.369C46.8833 24.9889 50.0035 26.7928 50.5044 30.5709C51.0056 29.0178 53.5533 26.9245 55.6 28.6895C57.4937 30.3229 57.6835 33.0596 57.4857 34.618H36.3125V34.6206Z",
    fill: "url(#paint3_linear_245_942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1598 47.3128C87.878 47.3128 88.4603 46.7336 88.4603 46.0192C88.4603 45.3048 87.878 44.7256 87.1598 44.7256C86.4416 44.7256 85.8594 45.3048 85.8594 46.0192C85.8594 46.7336 86.4416 47.3128 87.1598 47.3128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.322 48.3926C99.8751 48.3241 99.4233 48.2876 98.9707 48.2834C96.2423 48.2639 93.6427 49.4538 91.859 51.5389C90.0753 53.6237 89.287 56.3938 89.7023 59.1171",
    stroke: "white",
    strokeWidth: 10.395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.813 49.0107C100.813 51.7768 99.7086 54.4295 97.7423 56.3854C95.7761 58.3413 93.1093 59.4401 90.3286 59.4401V59.4401C87.5479 59.4401 84.881 58.3413 82.9148 56.3854C80.9485 54.4296 79.8438 51.7768 79.8438 49.0107V49.0107C79.8438 46.2446 80.9484 43.5918 82.9147 41.6358C84.881 39.6799 87.5478 38.5811 90.3286 38.5811V38.5811C93.1093 38.5811 95.7762 39.6799 97.7425 41.6358C99.7088 43.5918 100.813 46.2446 100.813 49.0107V49.0107Z",
    stroke: "white",
    strokeWidth: 10.395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.792 80.0352H77.4523C76.866 80.0352 76.3906 80.508 76.3906 81.0912V81.0915C76.3906 81.6747 76.866 82.1475 77.4523 82.1475H104.792C105.379 82.1475 105.854 81.6747 105.854 81.0915V81.0912C105.854 80.508 105.379 80.0352 104.792 80.0352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.794 73.6982H79.5773C78.991 73.6982 78.5156 74.1711 78.5156 74.7543V74.7545C78.5156 75.3378 78.991 75.8106 79.5773 75.8106H104.794C105.38 75.8106 105.856 75.3378 105.856 74.7545V74.7543C105.856 74.1711 105.38 73.6982 104.794 73.6982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.792 67.3613H76.1242C75.5378 67.3613 75.0625 67.8342 75.0625 68.4174V68.4176C75.0625 69.0009 75.5378 69.4737 76.1242 69.4737H104.792C105.378 69.4737 105.853 69.0009 105.853 68.4176V68.4174C105.853 67.8342 105.378 67.3613 104.792 67.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.952 73.1704C56.8316 73.1704 57.5446 73.8797 57.5446 74.7546C57.5446 75.6296 56.8316 76.3389 55.952 76.3389C55.0724 76.3389 54.3594 75.6296 54.3594 74.7546C54.3594 73.8797 55.0724 73.1704 55.952 73.1704Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.633 78.9787C125.12 78.9787 124.704 79.3925 124.704 79.9029C124.704 80.4134 125.12 80.8271 125.633 80.8271C126.147 80.8271 126.562 80.4134 126.562 79.9029C126.562 79.3925 126.147 78.9787 125.633 78.9787Z",
    fill: "#986060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.204 51.4498C42.5443 51.4498 42.0095 51.9818 42.0095 52.638C42.0095 53.2942 42.5443 53.8262 43.204 53.8262C43.8637 53.8262 44.3984 53.2942 44.3984 52.638C44.3984 51.9818 43.8637 51.4498 43.204 51.4498Z",
    fill: "#986060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.829 44.7301C58.1693 44.7301 57.6345 45.2621 57.6345 45.9183C57.6345 46.5745 58.1693 47.1064 58.829 47.1064C59.4887 47.1064 60.0234 46.5745 60.0234 45.9183C60.0234 45.2621 59.4887 44.7301 58.829 44.7301Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.835 93.5016C125.495 93.5016 126.03 94.0335 126.03 94.6897C126.03 95.346 125.495 95.8779 124.835 95.8779C124.175 95.8779 123.641 95.346 123.641 94.6897C123.641 94.0335 124.175 93.5016 124.835 93.5016Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7726 98.6998C58.4323 98.6998 58.9671 99.2318 58.9671 99.888C58.9671 100.544 58.4323 101.076 57.7726 101.076C57.1129 101.076 56.5781 100.544 56.5781 99.888C56.5781 99.2318 57.1129 98.6998 57.7726 98.6998Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.179 31.7154C122.839 31.7154 123.373 32.2474 123.373 32.9036C123.373 33.5598 122.839 34.0918 122.179 34.0918C121.519 34.0918 120.984 33.5598 120.984 32.9036C120.984 32.2474 121.519 31.7154 122.179 31.7154Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.561 66.3048L124.703 64.4566L126.561 62.6084L128.419 64.4566L126.561 66.3048Z",
    stroke: "#E1E4E5",
    strokeWidth: 5.029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.337 61.3021C137.362 61.7675 135.273 60.1014 135.273 60.1014C135.273 60.1014 136.388 57.6817 138.364 57.2179C140.339 56.7525 142.427 58.417 142.427 58.417C142.427 58.417 141.312 60.8368 139.337 61.3021Z",
    fill: "url(#paint4_linear_245_942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.775 76.603C137.526 77.8023 140.2 76.964 140.2 76.964C140.2 76.964 140.034 74.1815 138.283 72.9832C136.532 71.7839 133.859 72.6212 133.859 72.6212C133.859 72.6212 134.025 75.4037 135.775 76.603Z",
    fill: "url(#paint5_linear_245_942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9378 65.0159C35.8062 68.9324 43.0402 68.1067 43.0402 68.1067C43.0402 68.1067 43.9974 60.931 40.1254 57.0168C36.257 53.1003 29.0268 53.9237 29.0268 53.9237C29.0268 53.9237 28.0694 61.0994 31.9378 65.0159Z",
    fill: "url(#paint6_linear_245_942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.219 66.7801C144.631 66.7801 143.344 68.0048 143.344 69.5155C143.344 71.0263 144.631 72.251 146.219 72.251C147.807 72.251 149.094 71.0263 149.094 69.5155C149.094 68.0048 147.807 66.7801 146.219 66.7801Z",
    fill: "#986060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5393 88.7294C51.3994 88.7294 49.6646 90.3994 49.6646 92.4594C49.6646 94.5195 51.3994 96.1895 53.5393 96.1895C55.6793 96.1895 57.4141 94.5195 57.4141 92.4594C57.4141 90.3994 55.6793 88.7294 53.5393 88.7294Z",
    fill: "#986060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2799 44.7416C49.7215 44.7416 48.4581 43.485 48.4581 41.9348C48.4581 40.3846 49.7215 39.1279 51.2799 39.1279C52.8382 39.1279 54.1016 40.3846 54.1016 41.9348C54.1016 43.485 52.8382 44.7416 51.2799 44.7416Z",
    fill: "#986060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.445 51.6324C126.996 51.6324 125.82 50.4634 125.82 49.0213C125.82 47.5792 126.996 46.4102 128.445 46.4102C129.895 46.4102 131.07 47.5792 131.07 49.0213C131.07 50.4634 129.895 51.6324 128.445 51.6324Z",
    fill: "#986060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.147 94.9962C133.843 94.9962 132.787 93.9449 132.787 92.648C132.787 91.3511 133.843 90.2998 135.147 90.2998C136.451 90.2998 137.508 91.3511 137.508 92.648C137.508 93.9449 136.451 94.9962 135.147 94.9962Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7513 79.9098C40.3799 79.9098 39.2682 78.8039 39.2682 77.4397C39.2682 76.0756 40.3799 74.9697 41.7513 74.9697C43.1227 74.9697 44.2344 76.0756 44.2344 77.4397C44.2344 78.8039 43.1227 79.9098 41.7513 79.9098Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.292 48.4241C138.617 48.4241 138.069 47.8793 138.069 47.2072C138.069 46.5351 138.617 45.9902 139.292 45.9902C139.968 45.9902 140.516 46.5351 140.516 47.2072C140.516 47.8793 139.968 48.4241 139.292 48.4241Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.203 34.7969C131.172 34.7969 130.336 33.9653 130.336 32.9395C130.336 31.9136 131.172 31.082 132.203 31.082C133.234 31.082 134.07 31.9136 134.07 32.9395C134.07 33.9653 133.234 34.7969 132.203 34.7969Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7853 60.5574C53.9599 61.2056 53.5732 61.8718 52.9215 62.0455C52.2699 62.2192 51.6001 61.8345 51.4255 61.1864C51.2509 60.5382 51.6376 59.8719 52.2892 59.6982C52.9409 59.5245 53.6107 59.9092 53.7853 60.5574Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2061 43.0502C35.5648 43.0502 35.045 42.5331 35.045 41.8952C35.045 41.2573 35.5648 40.7402 36.2061 40.7402C36.8473 40.7402 37.3672 41.2573 37.3672 41.8952C37.3672 42.5331 36.8473 43.0502 36.2061 43.0502Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.594 85.5696C143.903 85.5696 143.344 85.1242 143.344 84.5748C143.344 84.0255 143.903 83.5801 144.594 83.5801C145.284 83.5801 145.844 84.0255 145.844 84.5748C145.844 85.1242 145.284 85.5696 144.594 85.5696Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.428 23.8669C113.791 25.2159 112.987 26.6024 111.631 26.9638C110.275 27.3253 108.881 26.5248 108.517 25.1758C108.154 23.8269 108.959 22.4404 110.315 22.0789C111.671 21.7175 113.065 22.518 113.428 23.8669Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.843 36.7502H146.875C147.069 39.4791 149.109 39.5211 149.109 39.5211C149.109 39.5211 146.86 39.565 146.86 42.7184C146.86 39.565 144.61 39.5211 144.61 39.5211C144.61 39.5211 146.649 39.4791 146.843 36.7502ZM61.5177 14.7002H61.5559C61.7831 17.9651 64.1762 18.0155 64.1762 18.0155C64.1762 18.0155 61.5373 18.0675 61.5373 21.8402C61.5373 18.0675 58.8984 18.0155 58.8984 18.0155C58.8984 18.0155 61.2905 17.9651 61.5177 14.7002Z",
    fill: "#E1E4E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_942",
    x1: 106.089,
    y1: 152.118,
    x2: 66.1505,
    y2: -29.0242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_942",
    x1: 111.162,
    y1: 59.971,
    x2: 95.52,
    y2: -10.6893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_942",
    x1: 138.78,
    y1: 61.1488,
    x2: 138.616,
    y2: 26.8789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_245_942",
    x1: 46.4773,
    y1: 39.5058,
    x2: 46.5876,
    y2: 16.4259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_245_942",
    x1: 131.9,
    y1: 62.4592,
    x2: 149.155,
    y2: 54.2644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_245_942",
    x1: 142.594,
    y1: 80.5382,
    x2: 128.892,
    y2: 66.0129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_245_942",
    x1: 47.372,
    y1: 78.3938,
    x2: 19.6152,
    y2: 34.6523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 126,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/clean.6082a06f6eb7bd6c29c9b485017bb873.svg";
export { ForwardRef as ReactComponent };